module.exports = __webpack_public_path__ + "static/media/SC_H_08.d680657b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/heads/SC_H_08.png
// module id = 150
// module chunks = 0